import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Invest from './pages/Invest';
import Team from './pages/Team';
import Royalty from './pages/Royalty';
import Activities from './pages/Activities';
import Modal from './components/common/Modal';
import LoadingOverlay from './components/common/LoadingOverlay';
import { useUI } from './contexts/UIContext';
import './styles/index.css'; // Make sure this is importing the complete CSS file

const App = () => {
  const { activeTab, modalVisible, isLoading } = useUI();
  const [searchParams] = useSearchParams();
  
  // Check for referral in URL
  useEffect(() => {
    const refId = searchParams.get('ref');
    if (refId) {
      // Store referral ID in local storage for later use
      localStorage.setItem('referrerId', refId);
    }
  }, [searchParams]);

  // Render the active tab content
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'invest':
        return <Invest />;
      case 'team':
        return <Team />;
      case 'royalty':
        return <Royalty />;
      case 'activities':
        return <Activities />;
      default:
        return <Dashboard />;
    }
  };

  // Add a debugging message to make sure styles are loading
  useEffect(() => {
    console.log('Styles should be loaded from index.css');
  }, []);

  return (
    <div className="app">
      <Layout>
        {renderContent()}
      </Layout>
      
      {/* Global modal and loading overlay */}
      {modalVisible && <Modal />}
      {isLoading && <LoadingOverlay />}
    </div>
  );
};

export default App;